import styled from 'styled-components'

const MenuCloseButtonStyle = styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
`

export default MenuCloseButtonStyle
